import { render, staticRenderFns } from "./GeneralOpeningHours.vue?vue&type=template&id=71fcfc03&scoped=true&"
import script from "./GeneralOpeningHours.vue?vue&type=script&lang=js&"
export * from "./GeneralOpeningHours.vue?vue&type=script&lang=js&"
import style0 from "./GeneralOpeningHours.vue?vue&type=style&index=0&id=71fcfc03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fcfc03",
  null
  
)

export default component.exports